import { combineReducers } from 'redux';
import type { Action } from '../../../types.tsx';
import { boardAddNewIssueToSprintReducer } from './add-new-issue-to-sprint/reducer.tsx';
import { displayOptionsReducer } from './display-options/reducer.tsx';
import { isDraggingReducer } from './drag/reducer.tsx';
import { isIpBoardFailedReducer } from './ip-board-failed/reducer.tsx';
import { isPollingEnabledReducer } from './is-polling-enabled/reducer.tsx';
import type { BoardState } from './types.tsx';

export default combineReducers<BoardState, Action>({
	isPollingEnabled: isPollingEnabledReducer,
	isDragging: isDraggingReducer,
	displayOptions: displayOptionsReducer,
	boardAddNewIssueToSprint: boardAddNewIssueToSprintReducer,
	isIpBoardFailed: isIpBoardFailedReducer,
});
